<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
         <screenButton></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater">
      <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
               :items="items" :fields="fields" foot-clone>
        <template v-slot:head()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          {{ data.index + 1 }}
        </template>
        				<template v-slot:cell(materialData)="data" style="'left':' 80px';">
        				        {{ data.item.materialName }}/{{ data.item.materialModel?data.item.materialModel:'-' }}/{{ data.item.materialUnit }}
        				    </template>
        <template v-slot:table-colgroup="scope">
          <col
              v-for="field in scope.fields"
              :key="field.key"
              :style="{ width: field.key === 'materialData' ? '140px' : field.key === 'index' ?'30px':'100px',left: field.key === 'materialData' ? '140px' : '80px'}"
          />
        </template>
        <template v-slot:foot()="scope">
          <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
        </template>
        <template v-slot:foot(index)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
        </template>
        <template v-slot:foot(purchaseQuantity)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'purchaseQuantity')}}</div>
        </template>
        <template v-slot:foot(amountMoney)="data">
          <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amountMoney')}}</div>
        </template>
      </b-table>
      <!-- <div>{{items}}</div> -->
    </div>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import ContractService from '@/api/mater/contractService'

export default {
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'materialData', stickyColumn: true, label: ' 专业名称/规格/单位'},
        {key: 'materialCommonName', label: '常用名称'},
        {key: 'brandName', label: '品牌'},
        {key: 'purchaseQuantity', label: '采购数量'},
        {key: 'unitPrice', label: '含税单价（元）'},
        {key: 'amountMoney', label: '含税金额（元）'},
        {key: 'remarks', label: '备注'},
        {key: 'brand', label: '品牌'},
      ],
      items: [],
      businessId: '',
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        orders: []
      },
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      new ContractService().materialPurchaseTemp(query.id).then(res => {
        this.items = res.data.data;
        this.joint(["materialName", "materialModel", "materialUnit"])
        this.items.forEach(sub => {
          sub.id = sub.materialId
        })
      }).catch(e => {
        console.log(e)
      })
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

